<template>
	<mounting-portal mount-to="#portalvue-single-video">
		<div 
			v-if="!initPlay"
			class="relative">
			<button 
				class="w-full h-full"
				v-on:click="startPlaying()">
				<video-media
					:src="video.image"
					:alt="video.title_dv"
					playbutton="show" />
			</button>
		</div>

		<div v-show="initPlay">
			<vue-plyr ref="plyr">
				<div 
					id="player"
					:data-plyr-embed-id="video.youtube_id" 
					data-plyr-provider="youtube"></div>
			</vue-plyr>
		</div>
	</mounting-portal>
</template>

<script>
import VideoMedia from './VideoMedia.vue'

export default {
	props: ["video"],

	data() {
		return {
			playing: false,
			initPlay: false,
		};
	},

	components: {
		VideoMedia,
	},

	methods: {
		startPlaying() {
			this.initPlay = true;

			this.$refs.plyr.player.on("playing", () => {
				this.playing = true;
			});

			this.$refs.plyr.player.on("play", () => {
				this.playing = true;
			});

			this.$refs.plyr.player.on("pause", () => {
				this.playing = false;
			});

			this.$refs.plyr.player.play();
		},
	},
};
</script>